import React from 'react';

interface InlineResultsContextProps {
    visibleResultsCount: number;
    setVisibleResultsCount: (count: number) => void;
}

export const InlineResultsContext = React.createContext<InlineResultsContextProps>({
    visibleResultsCount: 0,
    setVisibleResultsCount: () => undefined,
});
